import { render, staticRenderFns } from "./EditType.vue?vue&type=template&id=5c750d02"
import script from "./EditType.vue?vue&type=script&lang=js"
export * from "./EditType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports